import { NgModule } from '@angular/core';
import { LibFetchingTransactionsIconComponent } from './lib-fetching-transactions-icon.component';

@NgModule({
  declarations: [LibFetchingTransactionsIconComponent],
  imports: [],
  exports: [LibFetchingTransactionsIconComponent],
})
export class LibFetchingTransactionsIconModule {}
